export const isMobileApp = () =>
  import.meta.env.VITE_APP_ENTRY === 'maquinista';
